var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:{ 'btn--simple' : _vm.simple },attrs:{"type":"button"},on:{"click":_vm.clearFilters}},[_c('span',{staticClass:"btn__text"},[_vm._v("Clear Filters")]),_c('span',{staticClass:"btn__swoop"})])
}
var staticRenderFns = []

export { render, staticRenderFns }